var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 11.4599C9.65831 11.4599 9.37498 11.1766 9.37498 10.8349V6.4599C9.37498 6.11823 9.65831 5.8349 9.99998 5.8349C10.3416 5.8349 10.625 6.11823 10.625 6.4599V10.8349C10.625 11.1766 10.3416 11.4599 9.99998 11.4599Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 14.3765C9.77498 14.3765 9.56663 14.2932 9.40829 14.1349C9.33329 14.0516 9.27498 13.9599 9.22499 13.8599C9.18332 13.7599 9.16665 13.6515 9.16665 13.5432C9.16665 13.3265 9.25829 13.1099 9.40829 12.9515C9.71663 12.6432 10.2833 12.6432 10.5917 12.9515C10.7417 13.1099 10.8333 13.3265 10.8333 13.5432C10.8333 13.6515 10.8083 13.7599 10.7666 13.8599C10.725 13.9599 10.6667 14.0516 10.5917 14.1349C10.4333 14.2932 10.225 14.3765 9.99998 14.3765Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.9599C9.4418 18.9599 8.87512 18.8182 8.37512 18.5265L3.42512 15.6682C2.42512 15.0849 1.80011 14.0099 1.80011 12.8515V7.15156C1.80011 5.99323 2.42512 4.91822 3.42512 4.33489L8.37512 1.47656C9.37512 0.893229 10.6168 0.893229 11.6251 1.47656L16.5751 4.33489C17.5751 4.91822 18.2002 5.99323 18.2002 7.15156V12.8515C18.2002 14.0099 17.5751 15.0849 16.5751 15.6682L11.6251 18.5265C11.1251 18.8182 10.5585 18.9599 10.0001 18.9599ZM10.0001 2.29321C9.65846 2.29321 9.30845 2.38489 9.00012 2.55989L4.05012 5.41821C3.43345 5.77655 3.05011 6.43489 3.05011 7.15156V12.8515C3.05011 13.5599 3.43345 14.2265 4.05012 14.5849L9.00012 17.4432C9.61679 17.8015 10.3835 17.8015 10.9918 17.4432L15.9418 14.5849C16.5585 14.2265 16.9418 13.5682 16.9418 12.8515V7.15156C16.9418 6.44323 16.5585 5.77655 15.9418 5.41821L10.9918 2.55989C10.6918 2.38489 10.3418 2.29321 10.0001 2.29321Z",
    fill: "#026C96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning2);
export default __webpack_public_path__ + "static/media/warning-2.3aebeeab53536d20c8d1849a60f7c790.svg";
export { ForwardRef as ReactComponent };